import { useTranslation } from "react-i18next";
import { Editor } from "@tiptap/react";
import { mdiFormatUnderline } from "@mdi/js";
import { FormattingToggle } from "./FormattingToggle";

type Props = {
  editor: Editor;
};

export function UnderlineFormattingToggle({ editor }: Props) {
  const { t } = useTranslation();

  return (
    <FormattingToggle
      icon={mdiFormatUnderline}
      tooltip={t("UnderlineFormattingToggle.tooltip")}
      pressed={editor.isActive("underline")}
      onPressedChange={() => editor.chain().focus().toggleUnderline().run()}
    />
  );
}
